// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Wraps ReactFlow state hooks for pipeline nodes and edges.
 */
import { useCallback } from 'react'
import { useNodesState, useEdgesState, addEdge } from '@xyflow/react'
import type { Connection, Edge, Node } from '@xyflow/react'
import type { PipelineNodeData } from '../../../core/contracts'

export const usePipelineFlowState = () => {
  const [nodes, setNodes, onNodesChange] = useNodesState<Node<PipelineNodeData>>([])
  const [edges, setEdges, onEdgesChange] = useEdgesState<Edge>([])

  const onConnect = useCallback(
    (connection: Connection) => setEdges(prev => addEdge(connection, prev)),
    [setEdges],
  )

  return { nodes, setNodes, onNodesChange, edges, setEdges, onEdgesChange, onConnect }
}
